<template>
  <v-card>
    <v-card-title class="justify-center">{{ $t("change_responder") }}</v-card-title>
    <v-card-text class="px-0">
      <v-row class="pb-6" style="text-align: center; overflow-y: auto; overflow-x: hidden">
        <v-col v-for="(responder, idx) in responders" :key="idx">
          <v-btn
            v-if="responder.id == selectedResponderId"
            color="#fc461c"
            outlined
            width="250"
            @click="handleResponderBtnClick(responder.id)"
            >{{ truncateName(responder.name) }}
          </v-btn>
          <v-btn
            v-if="responder.id != selectedResponderId"
            class="responder_not_selected"
            color="#fc461c"
            text
            width="250"
            @click="handleResponderBtnClick(responder.id)"
            >{{ truncateName(responder.name) }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions v-if="isOktype" class="pa-4 d-flex flex-column align-center">
      <v-btn
        :disabled="selectedResponderId === -1"
        :style="{ color: 'white' }"
        color="#fc461c"
        width="250"
        @click="completeServiceAsSelectedResponder(selectedResponderId)"
      >
        OK
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { createComponent, onMounted, PropType, value, Wrapper } from "vue-function-api";
import { completeInquiry } from "@/modules/staff/services/responder";
import { truncateText } from "@/framework/utilities/truncateText";
import { getBizResponder } from "@/modules/staff/services/responderApi";
import { QcBizResponder } from "@/modules/staff/objects/QcBizResponder";
import { ErrorService } from "@/framework/errors/ErrorService";
import { StaffService } from "@/framework/api/Staff/StaffService";
import { InquiryService } from "@/framework/api/Staff/ChatService/InquiryService";

export default createComponent({
  props: ["closeChatState", "okType"] as any as PropType<{
    closeChatState: string;
    okType: {
      type: boolean;
      default: false;
    };
  }>,
  setup(props, context) {
    const $route = context.root.$route;
    const responders: Wrapper<QcBizResponder[]> = value([]);
    const selectedResponderId = value(-1);
    const isOktype = value(props.okType);
    const inquiryService = new InquiryService();
    const errorService = new ErrorService();

    const handleResponderBtnClick = (responderId: number) => {
      if (isOktype.value) {
        selectedResponderId.value = responderId;
      } else {
        completeServiceAsSelectedResponder(responderId);
      }
    };

    const completeServiceAsSelectedResponder = async (responderId: number) => {
      // KTZNCHAT-14439: disable ok after click
      selectedResponderId.value = -1;
      const setLoggedInResponderRes = await inquiryService.setResponder(responderId);
      if (setLoggedInResponderRes.isErr()) {
        return await errorService.handleError(setLoggedInResponderRes.error);
      }
      const conversationId = $route.params.conversationId;
      if (conversationId) {
        await completeInquiry(conversationId, responderId, props.closeChatState);
        context.emit("handleCancel");
      } else {
        console.warn("Conversation ID is null, completion aborted");
      }
    };

    const cancel = () => {
      context.emit("handleCancel");
    };

    onMounted(async () => {
      console.log("Staff Header - mounted()");
      const res = await getBizResponder();
      if (res.isErr()) {
        return await errorService.handleError(res.error);
      }
      selectedResponderId.value = res.value.id;

      await new StaffService().fetchResponders().then((listRespondersApiRes) => {
        if (listRespondersApiRes.isErr()) {
          return errorService.handleError(listRespondersApiRes.error);
        }
        listRespondersApiRes.value.forEach((responder) => {
          if (responder.id == selectedResponderId.value) {
            responders.value.unshift(responder);
          } else responders.value.push(responder);
        });
      });
    });

    const truncateName = (name: string) => {
      return truncateText(name, 13, 20);
    };

    return {
      isOktype,
      responders,
      selectedResponderId,
      handleResponderBtnClick,
      completeServiceAsSelectedResponder,
      cancel,
      truncateName,
    };
  },
});
</script>

<style lang="scss" scoped>
.v-card__text {
  overflow-x: hidden;
}
</style>
